import { data } from "jquery";
import { GlobalService } from "app/services/global.service";
import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SellersService } from "app/modules/sellers/sellers.service";

@Component({
  selector: "app-view-coupon",
  templateUrl: "./view-coupon.component.html",
  styles: [],
})
export class ViewCouponComponent implements OnInit {
  @Input() couponInfo: any;
  loader = false;
  couponDetails: any;
  sellerList = [];
  storeInfo = {};

  constructor(
    public dialogRef: NgbActiveModal,
    public global: GlobalService,
    public sellerService: SellersService
  ) {}

  ngOnInit(): void {
    this.couponDetails = this.couponInfo.data;
    this.getAllSellerList();
  }

  getAllSellerList() {
    this.loader = true;
    this.sellerService.getSellersByName("").subscribe((data) => {
      this.sellerList = data;
      this.storeInfo = this.sellerList.reduce(
        (obj, item) =>
          Object.assign(obj, {
            [item["_id"]]: item,
          }),

        {}
      );
      this.loader = false;
    });
  }

  close() {
    this.dialogRef.close({ success: false });
  }
}
